import KafkaAccessPage from '@/views/KafkaAccess/KafkaAccessPage.vue';
import { Permissions } from '@/utils/constants';

export default [
    {
        path: '/kafka-access',
        name: 'kafka-access',
        component: KafkaAccessPage,
        meta: {
            title: 'Kafka Access',
            breadcrumbLabel: 'Kafka Access',
            requireAuth: true,
            accessRules: {
                permissions: {
                    values: [Permissions.READ_KAFKA_ACCESS]
                }
            }
        }
    }
];
